import {IHistoryService} from '@techsee/techsee-client-infra/lib/services/HistoryService';
import {IRoomService, IUploadToClipboard} from '@techsee/techsee-client-infra/lib/services/RoomService';

export interface ISignedData {
    blobImage: Blob;
    fileName: string;
    publicUrl: string;
    signedRequest?: string;
}

export interface ISharingParams {
    type: 'url' | 'dataUrl' | 'text';
    signedData?: ISignedData;
    url?: string;
    _id?: string;
    useOriginalImage?: boolean;
    data?: string;
    fileName?: string;
    tryAgain?: boolean;
}

export interface IImageUploadCallback {
    (
        id: string,
        payload: {
            data: {
                fileName: string;
                fileType: string;
                fileSize: number;
                triggeredSource?: string;
                isAuto?: boolean;
                isTemp?: boolean;
            };
        }
    ): Promise<any>;
}

export enum ActionTypes {
    copyToClipboard = 'copyToClipboard',
    download = 'download',
    sendByEmail = 'sendByEmail',
    share = 'share'
}

export interface ISharingModeActions {
    enable: boolean;
    icons: {
        enable: string;
        disable: string;
    };
    type: ActionTypes;
    alt: string;
}

export interface ISharingService {
    init(roomId: string): void;
    copyToClipboard(params: ISharingParams | ISharingParams[], purpose?: string): Promise<void>;
    copyTextToClipboard(textParam: ISharingParams, purpose?: string): void;
    uploadClipboardImage(img: Blob | string, fileName: string, presignedRequest?: any): Promise<any>;
    uploadRoomImage(
        img: Blob | string,
        options: any,
        cbSuccess: (url: string) => void,
        cbErr: (err: any) => void
    ): void;
    uploadAutoCollectedImage(img: Blob | string): Promise<void>;
    uploadTriggeredCollectedImage(img: Blob | string, source: string): Promise<void>;
    uploadImageS3(
        img: Blob | string,
        fileName: string | null,
        loggingEnabled: boolean,
        cbSign: IImageUploadCallback,
        cbSuccess: (url: string) => void,
        cbErr: (err: any) => void
    ): void;
    generateImageFileName(img: Blob | string, fileName?: string): Promise<{blob: Blob; imgFileName: string}>;
    imageToBlob(img: Blob | string, callback: (blob: Blob) => void): void;
    sendByEmail(mailTrigger: string, params: ISharingParams[]): Promise<void>;
    sendImagesToClient(params: ISharingParams[]): Promise<void>;
    download(params: ISharingParams): Promise<void>;
    getSignedDataForImageSharing(params: ISharingParams): Promise<ISignedData>;
    imageAsBase64(url: string, options?: any): Promise<string>;
    updateRoomService(roomService: IRoomService): void;
    updateHistoryService(historyService: IHistoryService): void;
    getShareModeActions(): ISharingModeActions[];
}
